/**
 * @name ProgressBar
 * @description Componente de barra de progreso
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CountUp from 'react-countup';

import { Flex, Typography } from '../../../styles';

// Material-UI
import MuiLinearProgress from '@material-ui/core/LinearProgress';

class ProgressBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      completed: 0
    };
  }

  componentDidMount() {
    const timer = setInterval(() => {
      this.setState((prevState) => ({
        completed: (prevState.completed === this.props.value) ? this.props.value : Math.min(prevState.completed + 1, this.props.value)
      }));
    }, 20);

    return () => { clearInterval(timer); };
  }

  render() {
    return (
      <Flex.Col flex="100%">
        <Flex.Row alignItems="baseline">
          {this.props.label && (
            <Typography.Small>
              <Typography.Medium>{this.props.label}</Typography.Medium>
            </Typography.Small>
          )}
          {this.props.showValue && (
            <Styled.Value>
              <CountUp end={this.props.value} decimals={this.props.value % 1 === 0 ? 0 : 2} delay={1} />
              <Typography.H6>{'%'}</Typography.H6>
            </Styled.Value>
          )}
        </Flex.Row>
        <Styled.BoxRow>
          <Styled.LinearProgress variant="determinate" colorBar={this.props.color} value={this.state.completed} />
        </Styled.BoxRow>
      </Flex.Col>
    );
  }
}

ProgressBar.propTypes = {
  // Color de la barra de progreso.
  color: PropTypes.string,
  // Etiqueta de la barra de progreso.
  label: PropTypes.string,
  // Boolean que indica si se muestra el valor de la barra de progreso.
  showValue: PropTypes.bool,
  // Valor de la barra de progreso.
  value: PropTypes.number.isRequired,
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.BoxRow = styled.div`
  width: 100%;
`;

Styled.Value = styled.div`
  display: flex;
  flex: 1;
  align-items: baseline;
  justify-content: flex-end;

  & > span, ${Typography.H6} {
    /* font-family: 'Bryant Pro Medium'; */
    font-variant: tabular-nums;
    font-size: ${(props) => props.theme.typography.heading6};
  }
`;

Styled.LinearProgress = styled(MuiLinearProgress)`
  height: 6px;
  border-radius: 6px;

  &.MuiLinearProgress-colorPrimary {
    background-color:  ${(props) => props.theme.colors.greyLight};
  }

  .MuiLinearProgress-barColorPrimary {
    background-color: ${(props) => props.colorBar ? props.theme.colors[props.colorBar] : props.theme.colors['blueMedium']};
  }
`;

export default ProgressBar;